import { createSlice, type Draft } from '@reduxjs/toolkit'

import postsApi from '../endpoints/posts'
import { trackId, untrackId } from './actions'
import { selectReducer, unselectReducer } from './reducers'
import { type PostsSlice } from './types'

const initialState: PostsSlice = {
  selectedIds: [],
  tracked: [],
}

const postsSlice = createSlice({
  name: 'posts',
  initialState,
  reducers: {
    select: selectReducer,
    unselect: unselectReducer,
  },
  extraReducers: (builder) =>
    builder
      .addCase(trackId, (state: Draft<PostsSlice>, action) => {
        state.tracked = [
          ...state.tracked.filter(({ id }) => id !== action.payload.id),
          action.payload,
        ]
      })
      .addCase(untrackId, (state: Draft<PostsSlice>, action) => {
        state.tracked = state.tracked.filter(({ id }) => id !== action.payload)
      })
      .addMatcher(
        postsApi.endpoints.removePosts.matchFulfilled,
        (state: Draft<PostsSlice>, action) => {
          const removed = Array.isArray(action.meta.arg.originalArgs)
            ? action.meta.arg.originalArgs
            : [action.meta.arg.originalArgs]

          state.selectedIds = state.selectedIds.filter((id) => id !== undefined)
          state.tracked = state.tracked.filter(
            ({ id }) => id === undefined || !removed.includes(id),
          )
        },
      ),
})

export default postsSlice.reducer
